import React from 'react'
import ExamTerminal from './ExamTerminal'
import { Monitor } from 'lucide-react'

const ExamTerminalWrapper = () => {
  return (
    <div className='mt-10'>
         {/* <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-100 to-purple-100 rounded-full border border-blue-200 mb-6 animate-pulse-glow">
            <Monitor className="h-5 w-5 text-blue-600 mr-2 animate-bounce" />
            <span className="text-blue-700 font-semibold">REAL-TIME EXAM RESULTS</span>
          </div>
           */}
          <h2 className="text-xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight text-center">
            Instant{' '}
            <span className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent animate-gradient-x">
              Performance
            </span>{' '}
            <br />
            Analytics
          </h2>
          
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed text-center">
            Get comprehensive exam results with detailed analytics, performance metrics, and actionable insights 
            delivered instantly upon completion
          </p>
        
        
    <div className="flex justify-center  mb-10 px-4  mt-4">
        <div className="bg-gray-900 rounded-xl shadow-lg font-mono w-full max-w-[600px] text-sm text-left">
<ExamTerminal />
        </div>
        </div>
        </div>
  )
}

export default ExamTerminalWrapper